export default __webpack_public_path__ + "static/media/CorporealGhostMastered4.a1f5cfa2.mp3";